import { Button } from "reactstrap";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";

const DocumentPagination = ({ pageNumber = 0, totalPages = 0, totalElements = 0, pageSize = 10, onPageChange }) => {
  if (!totalPages || totalPages <= 1) return null;

  const current = Number(pageNumber || 0);
  const pages = Array.from({ length: totalPages }, (_, index) => index)
    .filter((page) => page === 0 || page === totalPages - 1 || Math.abs(page - current) <= 1);

  return (
    <div className="doc-pagination">
      <div className="doc-pagination-info">
        {totalElements} lignes - page {current + 1}/{totalPages} - {pageSize}/page
      </div>
      <div className="doc-pagination-actions">
        <Button color="light" disabled={current <= 0} onClick={() => onPageChange(current - 1)}>
          <FaAngleLeft />
        </Button>
        {pages.map((page, index) => {
          const previous = pages[index - 1];
          return (
            <span key={page} className="d-inline-flex align-items-center gap-1">
              {index > 0 && page - previous > 1 ? <span className="doc-page-gap">...</span> : null}
              <Button
                color={page === current ? "primary" : "light"}
                className="doc-page-btn"
                onClick={() => onPageChange(page)}
              >
                {page + 1}
              </Button>
            </span>
          );
        })}
        <Button color="light" disabled={current >= totalPages - 1} onClick={() => onPageChange(current + 1)}>
          <FaAngleRight />
        </Button>
      </div>
    </div>
  );
};

export default DocumentPagination;
